// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { html } from "lit";
import { str } from "@lit/localize";
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    se3b4c857f91f80d7: `Keyboard shortcuts`,
    s49ca4bf0e63593da: `Close dialogs`,
    sbda32dab0c54ffdd: `Next slide`,
    sdcc5f064d591aefd: `Previous slide`,
    s5b56a21c08c842c4: `First slide`,
    s3d5b54e4d176209c: `Last slide`,
    s4b10acae683d2978: `Fullscreen`,
    sb32c8490570a8831: `Slide overview`,
    sf7c0eba7c822e3d6: `Bold`,
    s523eb9043213ff0d: `Italic`,
    sb206d700d26b14ff: `Underline`,
    sd0b6082239185272: `Select all`,
    s7417792bbe720149: `Redo`,
    s8f4be9f086eb530f: `Undo`,
    s9ab2385df7adbce0: `Highlight a row`,
    s9021935bcdd703b9: `Open a sidepanel`,
    s469437ae00d48e37: `Expand the current row`,
    s9373ade6d85b4388: `Collapse the current row`,
    s2b63dc08d32ccb09: `Scroll up`,
    s9dd12575273ac110: `Scroll down`,
    s480d27b7a8b69ce5: `Scroll left`,
    s5febcd9b311c16fe: `Scroll right`,
    s1967ea0b8a2b6015: `Run selected cell`,
    sd81eecf773db25fc: `Run all cells sequentially`,
    s60565faf8db3a5cb: `Run this and all the cells above`,
    s7db511600050e797: `Run this and all the cells below`,
    s89365ba6fa5cdb97: `Stop execution`,
    sbf84c104b8212e06: `Select cell above`,
    s62bc518b503d1c76: `Select cell below`,
    s1534ff9f453525e1: `Select first cell`,
    sdc599e1d5c823e75: `Select last cell`,
    s63b6edf663b6a3c5: `Add cell below`,
    sf0d3b85da03d1e55: `Delete selected cell`,
    sc835e30bc3bdd2fd: `Move cell up`,
    s56410a6c80d5215c: `Move cell down`,
    sed2d45e3f811c81d: `Basic`,
    s5c1ecf88259b79f9: `Presentation`,
    s392dc2954562a82b: `Text editor`,
    sc2873891e8c3be68: `Robots script editor`,
    sd90a1e198e1ac71e: `Esc`,
    s7e388025be643d0d: `Enter`,
    "shortcuts-home": `Home`,
    sd8f923198e0c5c6a: `End`,
    s032cd9f1245d3645: `Space`,
    se93a3eaf86201ae7: `Shift`,
    sf993c3199fefcb9c: `Alt`,
    s4802e47fe2e95134: `Option`,
    s6fb3409caa74b0a4: `Ctrl`,
    saf7a5eef69e5bb59: `Up arrow`,
    sca442b5dc0fd394c: `Down arrow`,
    s353873ecbaa3efe9: `Left arrow`,
    sf41a0c89409353dc: `Right arrow`,
    s5cad0782f12d34b2: `Equity`,
    s3ab6763097d7412f: `Equity Invest`,
    sd0864ea6cb6ef22e: `Community`,
    see0ef54044d25a50: `Book Admin Boards`,
    s299dc244af6aadff: `Customer Admin Boards`,
    sa4bb7742cdfc214e: `Director Boards`,
    sfe3d666017079dce: `BoardEffect`,
    sa05b93d8764f88ed: `Risk Manager`,
    saed6432f1517ea10: `Asset Manager`,
    s34d94212c9758944: `Strategy`,
    s0ccb779911d414a3: `Asset Inventory`,
    s47de2481b149190a: `Entities`,
    s3f809b62bcc2a44c: `Mission Control`,
    s5db46d120dcba694: `Assessments`,
    sd514ab1c93237dae: `Assurance Plans`,
    s08e6d298452e8f68: `Audit`,
    s199f5853f4e718f7: `Projects`,
    se2faf168207b0a48: `Frameworks`,
    s6db55a42bcb74cfc: `Issue Tracker`,
    sd1c09a62f063a73b: `Task Manager`,
    s6d5cb7af3fa87c78: `Task Tracker`,
    sfc6b9ce43d2c798c: `Timesheets`,
    sf2d615b20d62225a: `Scheduler`,
    sb888017adf7992b9: `Diligent Academy`,
    s0bae1af85a28bd4c: `Diligent Institute`,
    s14ba513bc8896c24: `Robots`,
    s2c2b04f2561a1d4b: `Analytics`,
    s7695095bb106d505: `Accuvio`,
    s5d9182f471cf98d1: `Compliance Maps`,
    sd1182e4e6a0ada64: `Policy Manager`,
    s2aa747e75ad1b409: `Third Party Manager`,
    s0910fa68dccfcaa6: `Data Market Intelligence`,
    sd76505ffae553332: `Research Portal`,
    s39cccc90e6fe1d7f: `Issue Manager`,
    s89ba33f94f92f3cc: `Identification Campaigns`,
    sa153c163bc11460d: `Activity Center`,
    sca1a826088564455: `Results`,
    sb21cca7db5de38f3: `Storyboards`,
    s884bcdca26998a48: `Reports`,
    s7deaf226ff8b192c: `Installers`,
    h4b6568de605796be: html `Boards &amp; Governance`,
    h85f4df4fdcb8beed: html `Risk &amp; Strategy`,
    hcd22a6d6c40d8786: html `Audit &amp; Analytics`,
    h229e7d06093c2f3f: html `ESG &amp; Diversity`,
    hb6b70f369f25a7ac: html `Compliance &amp; Ethics`,
    h0fca6d6cbb0506c0: html `Market Intelligence`,
    hc639dc8eaab7815d: html `Issues &amp; Reporting`,
    h722c4148bfbe6706: html `Education &amp; Certifications`,
    "nav-section-home": `Home`,
    sc8aa5792985e2ba3: `Platform Settings`,
    h4e84df3b11ed9b4f: html `Help &amp; Support`,
    s586d6bd2eca2da93: `Users`,
    s9f26843287bb592d: `Groups`,
    s2e109263b73c12d5: `Licenses`,
    sf5597bb9f2103d2a: `Activations`,
    sf9b1c0661a02d9f9: `Configuration`,
    sb4484b8d878dffff: `Activity Logs`,
    s24761a0cc8d9c0aa: `Organization`,
    sa872b0bfe51f2d40: `Org Structure`,
    s3736464cf8d6fa08: `Support`,
    "link-home": `Home`,
    s5e27738a2e8eb763: `Sign in`,
    s7cfe12cd14df9950: `Sign out`,
    sb061ff5a347a296e: `Profile`,
    s5a41c3a63f1c18af: `Profile Settings`,
    s74cb3d66f6a668e1: `Documentation`,
    s7a4f059aaa029719: `Connect`,
    s175d37c8eb04d73e: `Downloads`,
    s947f21967d65c480: `Marketplace`,
    s9fda4232f5e1876a: `Get help`,
    sbd63362a31200ab4: `Go to launchpad`,
    se65e4e6f3696e997: `Training`,
    sd1b2ae9109b29cf0: `Side navigation`,
    s4b81aa9512692c4d: `Collapse side navigation`,
    sf95b10c03a2d5872: `Open side navigation`,
    s70113bbc33303a81: `Help menu`,
    s58622fa7922ed03b: `Help menu button`,
    scdd4399eeeacd8f4: `Switch organization`,
    s2cfcd4e06c146db9: `Open organization switcher dialog`,
    s5d929ff1619ac0c9: `Search`,
    s45efff328e4d0a4d: `Search organizations`,
    sb752d83c4e4619bc: str `Switch to ${0}`,
    sa35ed9234d3d66ce: `No organizations found`,
    s5e8250fb85d64c23: `Close`,
    s0a860146c6f28d97: `Open keyboard shortcuts dialog`,
    s460bf77c46d93bb4: `Close shortcuts dialog`,
    sb284cd019b430d1e: `No app-specific shortcuts available.`,
    sd9fb2375a5c991c5: `We don't support specific shortcuts for this app but if you have any suggestions, please let us know.`,
    sc203eef710f83583: `We don't support specific shortcuts for this app.`,
    sa103c8e0c776e11c: `Request keyboard shortcuts`,
    s7eb1e34fc5ece4cd: `Profile menu`,
    s9df9510d60035af3: `Open profile menu`,
};
